import React, { useEffect, useState } from 'react';


interface IProps {
  user: string;
  role: string;
  onClickSettings?: Function;
  onClickLogout?: Function;
}

const UserTopRightInfo = ({ onClickLogout, onClickSettings, user, role } : IProps) => {
  const [id] = useState(Math.random().toString(36).substring(7));

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    // @ts-ignore
    el.onMenuClick = (menuItem) => {
      switch(menuItem) {
        case 'Settings':
          !!onClickSettings && onClickSettings();
        break;
        case 'Log out':
          !!onClickLogout && onClickLogout();
        break;
        default:
      }
    }
  }, [id]);
  // @ts-ignore
  return (<user-dropdown
    user={user}
    role={role}
    content={role === 'admin' ? 'Log out' : 'Settings, Log out'}
    id={id}
  />);
}

export default UserTopRightInfo;